import { render, staticRenderFns } from "./newsingleDetail.vue?vue&type=template&id=1ea295fe&scoped=true&"
import script from "./newsingleDetail.vue?vue&type=script&lang=js&"
export * from "./newsingleDetail.vue?vue&type=script&lang=js&"
import style0 from "./newsingleDetail.vue?vue&type=style&index=0&id=1ea295fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea295fe",
  null
  
)

export default component.exports